import StudentDto from "../../dto/StudentDto";

export default class StaffCreateRequest {
  students = [];
  constructor(datas) {
    datas.forEach(data => {
      const student = new StudentDto(data);
      this.students.push(student);
    });
  }
}
